import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Page } from "~/components/Page";
import TasksArchiveHeader from "~/pages/ProjectTasksArchive/TasksArchiveHeader";
import TasksArchiveItems from "~/pages/ProjectTasksArchive/TasksArchiveItems";

const ProjectTasksArchivePage = () => {
  const { t } = useTranslation();
  const title = t("Completed Tasks");
  const backTitle = t("Project Tasks");
  const { projectId } = useParams();

  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [completedCounters, setCompletedCounters] = useState({
    Tasks: 0,
    TaskLists: 0,
  });

  const handleOnLoadingStateChange = useCallback(
    (newLoadingState) => {
      setIsLoadingPage(newLoadingState);
    },
    [setIsLoadingPage]
  );

  const handleOnCountersChange = useCallback(
    (completedTasksCount, completedTaskListsCount) => {
      setCompletedCounters({
        Tasks: completedTasksCount,
        TaskLists: completedTaskListsCount,
      });
    },
    [setCompletedCounters]
  );

  return (
    <Page
      title={title}
      id="tasks_archive"
    >
      <Page.Header
        title={title}
        backUrl={`/projects/${projectId}/tasks`}
        backTitle={backTitle}
      />
      <Page.Body className="tw-flex tw-h-full tw-flex-col">
        <TasksArchiveHeader
          loading={isLoadingPage}
          completedCounters={completedCounters}
        />
        <TasksArchiveItems
          filterContainer="task-archive-actions"
          onCountersChange={handleOnCountersChange}
          onLoadingStateChange={handleOnLoadingStateChange}
        />
      </Page.Body>
    </Page>
  );
};

export default ProjectTasksArchivePage;
